// extracted by mini-css-extract-plugin
export default {"tabletImg":"xB","desktopImg":"yB","mobileImg":"zB","backgroundImage":"AB","content":"BB","rtbLeft":"CB","rtbRight":"EB","imageContainer":"FB","rtbBox":"GB","line":"HB","rtbLeftMobile":"IB","rtbDesktop":"JB"};
    if(module.hot) {
      // 1711394578551
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  